import { createTheme } from "@material-ui/core";
import { defaultThemeOptions } from "./defaultTheme";

export const yellowThemeOptions = {
  ...defaultThemeOptions,
  mapTab: {
    background: "#faefc2",
    iconColor: "#000",
    hover: {
      background: "#f3da70"
    },
    selected: {
      background: "#f3da70"
    },
    active: {
      background: '#cda811',
      borderColor: '#cda811'
    }
  },
  customCheckbox: {
    color: "#7a7a7a",
    offHover: '#f2f2ff'
  },
  customRadio: {
    color: "#7a7a7a",
    offHover: '#f2f2ff'
  },
  contentsInfo: {
    basetimeContainer: {
      background : 'rgba(128,128,128,.9)',
      color: '#fff8dc',
    }
  },
  legendBox: {
    background: "rgba(128, 128, 128, 0.9)",
    color: "rgb(255, 255, 255)"
  },
  message: {
    sendIcon: {
      background: "#434343ff",
      color: '#fff'
    },
    sendMessage: {
      background: "rgb(254, 209, 232)",
      color: "rgba(0, 0, 0, 0.87)"
    },
    receiveMessage: {
      background: "#A8DDFD",
      color: "rgba(0, 0, 0, 0.87)"
    }
  }
}
export const yellowTheme = createTheme(yellowThemeOptions);
